"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * Process pasted content, if there are multiple blocks that are not wrapped by a shared ancestor node,
 * change the tag of first and last node to be SPAN so that it will be merged into current block
 * @param root Root node of content to process
 */
function handleLineMerge(root) {
    var traverser = roosterjs_editor_dom_1.ContentTraverser.createBodyTraverser(root);
    var blocks = [];
    for (var block = traverser === null || traverser === void 0 ? void 0 : traverser.currentBlockElement; block; block = traverser.getNextBlockElement()) {
        blocks.push({
            start: block.getStartNode(),
            end: block.getEndNode(),
        });
    }
    if (blocks.length > 0) {
        processBlock(blocks[0]);
        processBlock(blocks[blocks.length - 1]);
        checkAndAddBr(root, blocks[0], true /*isFirst*/);
        checkAndAddBr(root, blocks[blocks.length - 1], false /*isFirst*/);
    }
}
exports.default = handleLineMerge;
function processBlock(block) {
    var _a, _b;
    var start = block.start, end = block.end;
    if (start == end && roosterjs_editor_dom_1.getTagOfNode(start) == 'DIV') {
        var node = roosterjs_editor_dom_1.changeElementTag(start, 'SPAN');
        block.start = node;
        block.end = node;
        if (roosterjs_editor_dom_1.getTagOfNode(node.lastChild) == 'BR') {
            node.removeChild(node.lastChild);
        }
    }
    else if (roosterjs_editor_dom_1.getTagOfNode(end) == 'BR') {
        var node = end.ownerDocument.createTextNode('');
        (_a = end.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(node, end);
        block.end = node;
        (_b = end.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(end);
    }
}
function checkAndAddBr(root, block, isFirst) {
    var _a;
    var blockElement = roosterjs_editor_dom_1.getBlockElementAtNode(root, block.start);
    var sibling = isFirst
        ? roosterjs_editor_dom_1.getNextLeafSibling(root, block.end)
        : roosterjs_editor_dom_1.getPreviousLeafSibling(root, block.start);
    if (blockElement === null || blockElement === void 0 ? void 0 : blockElement.contains(sibling)) {
        (_a = (isFirst ? block.end : block.start).parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(block.start.ownerDocument.createElement('br'), isFirst ? block.end.nextSibling : block.start);
    }
}
//# sourceMappingURL=handleLineMerge.js.map